/* Progressive enhancement: content and collection links work without JavaScript. */
(() => {
  if (customElements.get('pa-storefront')) return;
  class PAStorefront extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const select = (index, focus = false) => {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          const panel = this.panels[i];
          if (panel) panel.hidden = i !== index;
        });
        if (focus) this.tabs[index]?.focus();
        this.updateControls();
      };
      if (this.tabs.length && this.panels.length === this.tabs.length) {
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-tabs]').hidden = false;
        this.panels.forEach((panel, i) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[i].id);
        });
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => select(i), { signal });
          tab.addEventListener('keydown', event => {
            let next = i;
            if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (i + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            select(next, true);
          }, { signal });
        });
        select(0);
      }
      this.querySelectorAll('[data-step]').forEach(button => {
        button.addEventListener('click', () => {
          const rail = this.activeRail();
          if (!rail) return;
          const child = rail.firstElementChild;
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          const distance = child ? child.getBoundingClientRect().width + gap : rail.clientWidth * .85;
          const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
          rail.scrollBy({ left: Number(button.dataset.step) * distance * rtl, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }, { signal });
      });
      this.querySelectorAll('[data-rail]').forEach(rail => rail.addEventListener('scroll', () => this.updateControls(), { signal, passive: true }));
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.querySelectorAll('[data-rail]').forEach(rail => this.resizeObserver.observe(rail));
      // Selecting a product tab or story in the Shopify editor reveals its content.
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-panel]');
        if (panel) select(this.panels.indexOf(panel));
        const story = event.target.closest('.pa-story-card');
        if (story) story.scrollIntoView({ block: 'start', behavior: 'instant' });
      }, { signal });
      this.updateControls();
    }
    activeRail() {
      return [...this.querySelectorAll('[data-rail]')].find(rail => !rail.closest('[data-panel][hidden]'));
    }
    updateControls() {
      const rail = this.activeRail();
      const controls = this.querySelector('[data-rail-controls]');
      if (!rail || !controls) return;
      const overflow = rail.scrollWidth - rail.clientWidth;
      controls.hidden = overflow <= 2;
      const offset = Math.abs(rail.scrollLeft);
      const previous = controls.querySelector('[data-step="-1"]');
      const next = controls.querySelector('[data-step="1"]');
      previous.disabled = offset <= 2;
      next.disabled = offset >= overflow - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  }
  customElements.define('pa-storefront', PAStorefront);
})();
